<!--
 * @Author: your name
 * @Date: 2025-05-27 20:45:28
 * @LastEditTime: 2025-05-28 11:17:40
 * @LastEditors: niuzijie
 * @Description: In User Settings Edit
 * @FilePath: \yl-wxcx-coupon-front\src\views\checkGoods\oneYearNotify.vue
-->
<template>
  <div class="one-year-notify">
    <h1 class="title">快递信息查询时效更新告知书</h1>
    <p>尊敬的客户：</p>
    <p class="indent">您好！为给您带来更优质、高效的物流查询体验，我司对电话、官方网站、小程序等物流轨迹途径查询时效进行了全面优化。在此，特将相关情况向您公示说明。</p>
    <p class="indent">一、官方网站</p>
    <p class="indent">您进入官网首页后，在页面中找到运单查询框，输入单号，点击查询按钮，滑动滑块完成验证，即可查看物流轨迹。</p>
    <p class="indent">官方网站网址：https://www.jtexpress.cn/service.html</p>
    <p class="indent">二、官方热线</p>
    <p class="indent">拨打官方服务热线 956025，通过智能语音查包裹状态，即可获取物流轨迹最新状态，如需要转人工服务的，语音告知转人工，重复两次即可进入人工客服咨询。</p>
    <p class="indent">热线客服人工服务时间：08：30-20：00</p>
    <p class="indent">在线客服人工服务时间：08：30-21：00</p>
    <p class="indent">智能客服服务时间：00：00-24：00</p>
    <p class="indent">三、小程序</p>
    <p class="indent">微信小程序搜索 “极兔速递 +”，进入小程序后，在查件界面输入快递单号，即可查询近 1 年的快件物流轨迹。为保障您的信息安全，查询时需填写快递预留的收 / 寄件人手机号 / 座机号后四位进行验证，请您提前准备好相关信息。</p>
    <p class="fontB indent">此功能拟于2025年6月1日上线运行。</p>
    <p class="indent">我们始终致力于为您提供最优质的物流服务，此次官网物流轨迹查询时效优化是我们提升服务质量的重要举措之一。感谢您一直以来对我们的支持与信任，若您对此次优化有任何疑问或建议，欢迎随时与我们联系。我们将竭诚为您服务，不断改进，为您创造更便捷、高效的物流体验。</p>
    <p class="indent">我司后续将持续对支付宝、百度、微博小程序及智能机器人的查询服务时效进行全面更新升级，为您带来更高效、便捷的查询体验，敬请期待！</p>
  </div>
</template>

<script>
export default {
}
</script>

<style lang="scss" scoped>
.one-year-notify {
  background: #ffffff;
  box-sizing: border-box;
  padding: 16px 16px 32px 16px;
  font-size: 14px;margin-bottom:8px;display: block;
  color: #000000;
  line-height: 28px;
  font-family: 宋体;

  .title {
    text-align: center;
    font-size: 16px;
    font-weight: bold;
  }

  .indent {
    text-indent: 2em;
  }

  .fontB {
    font-weight: bold;
  }

  p {
    word-break: break-all;
  }
}
</style>

